import { Component, HostListener, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, LazyLoadEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { BehaviorSubject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { FilterVersion, GlobalMessage,Scripts } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VersionupdateService } from './versionupdate.service';
import { VersionupdatefiltersComponent } from '../../directives/filters/versionupdatefilters/versionupdatefilters.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { VersionupdatemodalComponent } from '../../directives/versionupdatemodal/versionupdatemodal.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-versionupdate',
  templateUrl: './versionupdate.component.html',
  styleUrls: ['./versionupdate.component.css']
})
export class VersionupdateComponent {

  @ViewChild('dt') dt: Table; // ViewChild for accessing p-table
  @ViewChild(VersionupdatefiltersComponent) filtersComponent!: VersionupdatefiltersComponent;
  filterinput: FilterVersion = new FilterVersion();
  filtersData: FilterVersion = new FilterVersion();

  items: MenuItem[] = [];
  selectedItem: MenuItem | null = null;
  tableData: any[] = [];
  listarray: Array<any> = [];
  dbscriptsUpdatereq: Scripts = new Scripts();
  ref: DynamicDialogRef | undefined;
  paginatorArray = [];
  _selectedColumns: any[];
  commonScrollHeight = '';
  tempuse: any;
  showcount: number = 0;
  hidecount: number = 0;
  firstrowingrid: number = 0;
  numberofrowsingrid: number = 10;
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 20, 50, 100];
  tablecount: number = 0;
  totalRecords: number = 0;
  options = [{ label: 10, value: 10 }];
  selectedColumns = ''
  psition = 'top';
  activeIcon = '0'
  cols: any[];
  templatedownloadtext = '';
  excel_paragraph = '';
  exceldownloadModal = false;
  customsort: boolean = true;
  versionid = '';
  productid = '';
  ownerid = '';
  message: GlobalMessage = new GlobalMessage();
  isExpanded = false;
  showMore = false;
  isActivefilter = false

  filterseleteditems = [];
  maxVisibleItems = 10;
  selecteditems = new BehaviorSubject<any>([]);
  isglobalfilter = false

  isTableHeaderCustomized: boolean = false;

  private subscription!: Subscription;

  constructor(
    private versionupdateService: VersionupdateService,
    public router: Router, private utilityserv: Utilityservice,
    public dialogService: DialogService,
    public helpservice: PagehelpmodalService, 
    private titleService: Title, private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text

    this.utilityserv.refreshfilter.subscribe(res => {
      if (res == 'reset') {
        this.isActivefilter = false
      }
    });


    this.subscription = this.versionupdateService.selecteditems.subscribe(res => {
      this.filterseleteditems = res
    })


  }

  ngOnInit() {
    this.activatedRoute.data.subscribe((res: any) => {
      this.titleService.setTitle(res.title || 'Version Update'); 
    })

    this.commonScrollHeight = this.utilityserv.scrollHeight
    this.commonScrollHeight = this.utilityserv.updateScrollHeight(); 
    //    this.getdbscripts();
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.commonScrollHeight = this.utilityserv.updateScrollHeight();
  }

  filters: {}

  gettabledata(event?: LazyLoadEvent) {
    this.versionupdateService.filtersObservable.subscribe(res => {
      this.filterinput = res;
      this.numberofrowsingrid = event?.rows || this.numberofrowsingrid;
      let page = Math.floor(this.firstrowingrid / this.numberofrowsingrid) + 1;
      this.spinner.show();
      if (event.sortField) {
        this.filterinput['sortField'] = event.sortField
        res['sortOrder'] = event.sortOrder
      }
      if (event.filters) {
        this.filterinput['filters'] = event.filters
      }
      event.globalFilter, "event.globalFilter";
      if (event.globalFilter !== null) {
        this.isglobalfilter = true
      } else {
        this.isglobalfilter = false
      }

      this.filterinput['page'] = page;
      this.filterinput['size'] = this.numberofrowsingrid;
      const currentPageSize = this.numberofrowsingrid;

      this.versionupdateService.gettabledata(this.filterinput).subscribe((data: any) => {
        this.listarray = data.versionupdatedata || [];
        this.spinner.hide();
        this.options = this.utilityserv.getOptionDropdown(data.totalcount);
        this.paginatorArray = this.options.map((e) => e.value);
        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.paginatorArray = this.options.map(e => e.value)
        this.listarray.map(e => {
          e['isSelect'] = false
        })
        this.totalRecords = data.totalcount;

        // if (event.sortField) {
        //   this.utilityserv.sortData(event.sortField, event.sortOrder, this.listarray);
        // }

      },
        error => {
          this.spinner.hide();
          const timestamp = new Date().toLocaleString(); // example timestamp
          Swal.fire({
            title: error.error.error,
            text: `This event occurred at: ${timestamp}`,
            icon: 'error'
          })
        });
    });

  }



  show(title, data) {
    let details = {};
    if (title === 'Modify') {
      this.spinner.show();
      this.versionupdateService.getVersionById(data.id).subscribe((res: any) => {
        this.spinner.hide();
        if (res.length === 0) {
          const timestamp = new Date().toLocaleString(); // example timestamp
          Swal.fire({
            title: 'Data Not Found',
            text: `This event occurred at: ${timestamp}`,
            icon: 'error'
          })
        } else {
          details = res;
          this.ref = this.dialogService.open(VersionupdatemodalComponent, {
            header: title,
            width: '90vw',
            height: '100%',
            data: { title: title, datas: details },
            contentStyle: { overflow: 'hidden' },
            maximizable: true,
          });
          this.ref.onClose.subscribe(() => {
            this.gettabledata({ first: this.firstrowingrid, rows: this.numberofrowsingrid });
          });
        }
      }, error => {
        this.spinner.hide();
        const timestamp = new Date().toLocaleString(); // example timestamp
        Swal.fire({
          title: error.error.error,
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        })

      });
    } else {
      details = {};
      this.ref = this.dialogService.open(VersionupdatemodalComponent, {
        header: title, width: '90vw', height: '100%',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        this.gettabledata({ first: this.firstrowingrid, rows: this.numberofrowsingrid });
      });
    }
  }

  viewData(data) {
    this.spinner.show();
    this.versionupdateService.getVersionDataView(data.id).subscribe(res => {
      this.spinner.hide();
      this.ref = this.dialogService.open(VersionupdatemodalComponent, {
        header: 'View Version Update',
        height: '100%',
        width: "98%",
        data: { title: 'View Version Update', datas: res },
        // contentStyle: { overflow: 'hidden'  },
        baseZIndex: 10000,
        maximizable: true,
      });
    }, error => {
      this.spinner.hide();
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      })
    })
  }
  /*
      dynamiccols(){
      this.showcount = 8;
      this.hidecount = 3;
      this.cols = [];
    
     this.cols.push(
       {fieldname:'requirementid',headername:'ReqID',fieldtype:'text',issort: true , ischecked:true,width:'2px !important', class:'headerid'},
       {fieldname:'versionname',headername:'Version',fieldtype:'text',issort: true , ischecked:true,  width:'2px !important',class:'otherheader'},
       {fieldname: "productinitial", headername: "Product",fieldtype:'text',issort: true , ischecked:true, width:'20px',class:'otherheader' }, 
       {fieldname: "releaseddate", headername: "Released Date",fieldtype:'text',issort: true , ischecked:true, width:'20px',class:'otherheader' }, 
       {fieldname: "feature", headername: "Feature",fieldtype:'text',issort: true ,  ischecked:true, width:'200px',class:'otherheader' } ,
       {fieldname: "categoryname", headername: "Category",fieldtype:'text',issort: true ,  ischecked:true, width:'20px',class:'otherheader' } ,
       {fieldname: "advantageoffeature", headername: "Advantage",fieldtype:'text',issort: false ,  ischecked:true, width:'20px',class:'otherheader' }, 
       {fieldname: "usedfunctionality", headername: "Functionality",fieldtype:'text',issort: true , ischecked:true, width:'20px',class:'otherheader' }, 
       {fieldname: "towhom", headername: "To whom",fieldtype:'text',issort: true , ischecked:true, width:'20px',class:'otherheader' } 
     )
    
     const payload = {
       userid: this.utilityserv.getLoggeduser().userid,
       orgid: this.utilityserv.getLoggeduser().orgid, productid: 14,
       componentname: 'versionupdate'
     }
     this.spinner.show();
     this.utilityserv.getuserxcolumn(payload).subscribe(res => {
       this.spinner.hide();
       this.cols.forEach(column => {
         const matchingColumn = res.find(x => x.fieldname === column.fieldname);
         if (matchingColumn) {
           column.ischecked = matchingColumn.ischecked;
           column.issort = matchingColumn.issort;
         }
       });
         this._selectedColumns = this.cols;
       this.isTableHeaderCustomized = this.cols.some(col => col.ischecked !== true);
     }, error => {
       this.spinner.hide();
       console.error('Error getting user columns:', error);
       Swal.fire('Error getting header filter', 'Please try again later', 'error');
     })
     this.utilityserv.headerObservable.next(this.cols);
    
    }
  */
  //Download  Excel
  exceDownloadModel() {
    this.versionupdateService.filtersObservable.subscribe(res => {
      this.filterinput = res;
    })

    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '44vw',
      height: '10vw',
      data: {
        excelname: "Versionupdate.xlsx", downloadapi: 'common/versionupdate/exceldatadownload',
        method: 'post', message: this.excel_paragraph, payload: this.filterinput
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center'

    })
  }


  showTableColumns() {
    this.isActivefilter = !this.isActivefilter;
  }

  handlePageChange(event: any) {
    this.firstrowingrid = event.first; // Update start index for pagination
    this.numberofrowsingrid = event.rows;
    this.gettabledata(event)
  }

  onGlobalSearch(value) {
    alert(value);
    this.firstrowingrid = this.firstrowingrid || 0;
    this.numberofrowsingrid = this.numberofrowsingrid || 10;
    this.gettabledata({
      first: this.firstrowingrid,
      rows: this.numberofrowsingrid,
      filters: this.filters,
      globalFilter: value,
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }

  get displayedItems() {

    return this.showMore ? this.filterseleteditems : this.filterseleteditems.slice(0, this.maxVisibleItems);
  }
  get remainingCount() {
    return this.filterseleteditems.length - this.maxVisibleItems;
  }
  toggleMore(event) {
    event.stopPropagation();

    this.showMore = !this.showMore;
    setTimeout(() => {
      const accordionHeader = document.querySelector('.p-accordion .p-accordion-header');
      if (accordionHeader) {
        accordionHeader.classList.toggle('expanded', this.showMore);
      }
    }, 10);
  }
  removeItem(event, item: string) {
    event.stopPropagation();
    if (item === 'Product') { this.filterinput.tproduct = ''; }
    else if (item === 'Version') { this.filterinput.tversionid = ''; }
    else if (item === 'Category') { this.filterinput.tcategory = ''; }
    else if (item === 'From Date') { this.filterinput.tfromdate = ''; }
    else if (item === 'To Date') { this.filterinput.ttodate = ''; }
    this.versionupdateService.getFilterChange(this.filterinput);
    this.filterseleteditems = this.filterseleteditems.filter(i => i !== item);
    this.filtersComponent.selectitems = this.filterseleteditems;
    this.versionupdateService.selecteditems.next(this.filterseleteditems);
  }


  refreshData(h) {
    h.stopPropagation();
    this.versionupdateService.filterrefresh();
    this.versionupdateService.selecteditems.next([])
    this.filterseleteditems = [];
    this.filtersComponent.filterinput = new FilterVersion;
    this.filterinput = new FilterVersion;
    this.filtersComponent.filterVersion = new FilterVersion();
    this.filtersComponent.selectitems = this.filterseleteditems;
    this.versionupdateService.getFilterChange(this.filtersComponent.filterVersion);
  }

  gettodatetooltip() {
    if (!this.filterinput.ttodate) {
      return 'Select To Date'
    }
    const selected = this.formatDate(this.filterinput.ttodate, 'DD-MMM-YYYY');
    return selected ? selected : 'Select To Date';

  }
  getfromdatetooltip() {
    if (!this.filterinput.tfromdate) {
      return 'Select From Date'
    }
    const selected = this.formatDate(this.filterinput.tfromdate, 'DD-MMM-YYYY');
    return selected ? selected : 'Select From Date';

  }
  formatDate(value: any, format: string = 'DD-MMM-YYYY') { // convert for save payload
    if (typeof value === 'string' && value.trim()) {
      return moment(value).format(format);
    } else if (value instanceof Date) {
      return moment(value).format(format);
    } else {
      return '';
    }
  }

  searchTerm: string = '';
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}
